import { render } from "./ListMembersPage.vue?vue&type=template&id=ddca5de4&ts=true"
import script from "./ListMembersPage.vue?vue&type=script&lang=ts"
export * from "./ListMembersPage.vue?vue&type=script&lang=ts"

import "./ListMembersPage.vue?vue&type=style&index=0&id=ddca5de4&lang=scss"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__